import { Routes } from '@angular/router';
import { SignaturePageComponent } from './features/signature/pages/signature-page/signature-page.component';

export const routes: Routes = [
  {
    path: '',
    component: SignaturePageComponent
  }
];
